export default {
  units: {
    time: {
      name: "second",
      pluralName: "seconds",
      symbol: "s"
    }
  }
};
